<template>

<div class="row">

	<div class="col-md-12" v-if="dataReady">

		<div class="alert alert-success alert-with-icon text-center" v-if="isPending">
			<h4><i class="fa fa-bell"></i></h4>
			<p>
				Регистрацията Ви изчаква одобрение от АДО!<br>
				Ако искате може да редактирате детайлите на вашата регистрация.
			</p>
		</div>
		<div class="alert alert-warning alert-with-icon text-center" v-else>
			<h4><i class="fa fa-bell"></i></h4>
			<p>
				Тъй като влизате за първи път в <strong>"Семейна образователна мрежа"</strong>, ще трябва да регистрирате своя семеен профил.<br>
				Регистрацията Ви трябва да бъде одобрена от АДО, за да получите достъп до мрежата.
			</p>
		</div>

		<!-- Starter -->
		<div class="card wizard-page">
			<div class="card-block">
				<h4 class="card-title">{{$t('label.family_name')}} <small class="pull-right">1/5</small></h4>

				<f-input v-model="family.name" name="family_name" hide-name v-validate="'required'" :errors="errorBag.collect('family_name')" cplaceholder="(пример: Иван и Мария Иванови)">
				</f-input>
			</div>
		</div>

		<!-- People -->
		<div class="card wizard-page">
			<div class="card-header">
				<h4 class="card-title">{{$t('label.family_people')}} <small class="pull-right">2/5</small></h4>
			</div>
			<div class="card-block">

				<div class="form-group">
					<h5 class="card-sub-title">{{$t('label.family_parents')}}</h5>

					<div class="table-responsive">
						<table class="table table-bordered">
							<tbody>
								<tr v-for="(roleDescription, role) in $config.lists.familyRoles">
									<template v-for="user in usersByRole[role]">
										<td class="vertical-middle">
											<label class="custom-control custom-radio">
												<input type="radio" class="custom-control-input" v-model="family.role" :value="role">
												<span class="custom-control-indicator" :class="{'bg-success': family.role === role}"></span>
												<span class="custom-control-description">{{ roleDescription.text }}</span>
											</label>
										</td>
										<td class="vertical-middle" style="width: 1px; padding-right: .4rem !important;">
											<label class="control-label">{{$t('label.person_name')}}:</label>
										</td>
										<td class="vertical-middle">
											<f-input v-model="user.name" name="person_name" hide-name v-validate="'required'" :errors="errorBag.collect('person_name', 'user.' + user.id)" :cplaceholder="'(пример: ' + roleDescription.placeholder + ')'" :data-vv-scope="'user.' + user.id"></f-input>
										</td>
										<td class="vertical-middle" style="width: 1px; padding-right: .4rem !important;">
											<label class="control-label">{{$t('label.person_interests')}}:</label>
										</td>
										<td class="vertical-middle">
											<f-input v-model="user.interests" name="person_interests" hide-name cplaceholder="(разделени със запетая)" :data-vv-scope="'user.' + user.id"></f-input>
										</td>
									</template>
									<template v-if="usersByRole[role].length === 0">
										<td colspan="5" class="text-center">
											<button class="btn btn-info" @click="addParent(role)"><i class="fa fa-plus"></i> {{roleDescription.text}}</button>
										</td>
									</template>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="form-group">
					<h5 class="card-sub-title">{{$t('label.family_children')}}</h5>

					<div class="table-responsive">
						<table class="table table-bordered table-hover">
							<thead>
								<tr >
									<th class="text-center" style="width: 6ex">#</th>
									<th class="text-center">{{$t('label.person_name')}}</th>
									<th class="text-center">{{$t('label.person_sex')}}</th>
									<th class="text-center">{{$t('label.person_birth_year')}}</th>
									<th class="text-center"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(child, key) in usersByRole.child">
									<td class="text-center vertical-middle">{{ key + 1 }}</td>
									<td class="vertical-middle">
										<f-input v-model="child.name" name="person_name" hide-name v-validate="'required'" :errors="errorBag.collect('person_name', 'user.' + child.id)" :data-vv-scope="'user.' + child.id" cplaceholder="Име"></f-input>
									</td>
									<td class="vertical-middle">
										<f-select v-model="child.role" name="person_sex" hide-name v-validate="'required'" :errors="errorBag.collect('person_sex', 'user.' + child.id)" :data-vv-scope="'user.' + child.id" :values="$config.lists.childRoles"></f-select>
									</td>
									<td class="vertical-middle">
										<f-input v-model="child.birthYear" name="person_birth_year" hide-name v-validate="'required'" :errors="errorBag.collect('person_birth_year', 'user.' + child.id)" :data-vv-scope="'user.' + child.id"></f-input>
									</td>
									<td class="vertical-middle">
										<button @click="removeChild(key)" class="btn btn-small btn-danger btn-icon remove"><i class="fa fa-remove"></i></button>
									</td>
								</tr>
								<tr>
									<td colspan="5" class="text-center">
										<button class="btn btn-info" @click="addChild()"><i class="fa fa-plus"></i></button>
										<!-- <button class="btn btn-info" @click="addChild()">{{$t('label.person_add')}}</button> -->
									</td>
								</tr>
							</tbody>
						</table>
						<br>
					</div>
				</div>
			</div>
		</div>

		<!-- Location -->
		<div class="card wizard-page">
			<div class="card-header">
				<h4 class="card-title">{{$t('label.family_location')}} <small class="pull-right">3/5</small></h4>
			</div>
			<div class="card-block">
				<f-select v-model="family.country" :values="$config.lists.countries" name="family_country" v-validate="'required'" :errors="errorBag.collect('family_country')"></f-select>
				<f-select v-model="family.state" :values="$config.lists.states" name="family_state" v-validate="'required'" :errors="errorBag.collect('family_state')"></f-select>
				<f-input v-model="family.city" name="family_city" cplaceholder="(не е задължително)"></f-input>
			</div>
		</div>

		<!-- Homeschooling Information -->
		<div class="card wizard-page">
			<div class="card-header card-header-text">
				<h4 class="card-title">{{$t('label.family_about_us')}} <small class="pull-right">4/5</small></h4>
			</div>
			<div class="card-block">

				<h5 class="card-sub-title">{{$t('label.family_experience')}}</h5>
				<f-input v-model="family.info.hsExperience" name="family_experience" hide-name v-validate="'numeric'" :errors="errorBag.collect('family_experience')" cplaceholder="(пример: 1)">
				</f-input>

				<h5 class="card-sub-title">{{$t('label.family_methods')}}</h5>
				<p>Моля, изберете методите за домашно образование, които използвате във вашето семейство.</p>
				<div class="row hs_method" v-for="(method, key) in $config.lists.hsmethods">
					<div class="col-md-3">
						<label class="custom-control custom-checkbox">
							<input type="checkbox" v-model="family.info.hsMethods" :value="key" class="custom-control-input">
							<span class="custom-control-indicator" :class="{'bg-success': family.info.hsMethods.indexOf(key) !== -1}"></span>
							<span class="custom-control-description"><strong style="color:black">{{ method.name }}</strong></span>
						</label>
					</div>
					<div class="col-md-8">
						{{ method.desc }}
					</div>
				</div>
			</div>
		</div>

		<!-- Notes -->
		<div class="card wizard-page">
			<div class="card-header card-header-text">
				<h4 class="card-title">{{$t('label.family_admin_note')}} <small class="pull-right">5/5</small></h4>
			</div>
			<div class="card-block">
				<p>
					Моля, пишете ни от коя среща за домашно образование се познаваме, за да можем да одобрим достъпа ви до мрежата.
				</p>
				<f-textarea v-model="family.note" name="family_admin_note" hide-name cplaceholder="" :crows="15">
				</f-textarea>
			</div>
		</div>

		<!-- Footer -->
		<div class="card wizard-page">
			<div class="card-block">
				<div class="text-center">
					<button type="submit" class="btn btn-fill btn-primary" @click="onSubmit()">Запис</button>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

module.exports = {
	data: function () {
		return {
			family: {
				role: '',
				name: '',
				users: [],
				country: undefined,
				state: undefined,
				city: '',
				info: {
					about: '',
					interests: '',
					hsExperience: 0,
					hsMethods: []
				},
				note: ''
			},
			dataReady: false,
			isPending: false
		};
	},
	computed: {
		usersByRole: function () {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			if (!this.$user.registration) {
				this.dataReady = true;
				this.isPending = false;
			} else {
				this.$http.get('backend://registration/' + this.$user.registration).then((result) => {
					this.family = result.body;
					this.dataReady = true;
					this.isPending = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function () {
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[ i ];
				if (member.name === '') {
					this.family.users.splice(i, 1);
					i--;
				}
			}
			if (this.usersByRole.mother.length === 0 && this.usersByRole.father.length === 0) {
				this.$toasted.show('Моля, попълнете името на поне един родител').goAway(1500);
				return;
			}

			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.putOrPostResource('backend://registration/', this.family).then((response) => {
					this.$user.refresh().then(() => {
						window.scrollTo(0, 0);
						this.$toasted.show('Записването на информацията е успешно! Регистрацията Ви изчаква одобрение.').goAway(1500);
						this.fetchData();
					});
				}).catch(this.$http.toastCatcher);
			});
		},
		addChild: function () {
			this.family.users.push({name: '', role: 'son', birthYear: 2000, id: 0});
		},
		addParent: function (role) {
			this.family.users.push({name: '', role: role, interests: '', id: 0});
			this.family.role = this.family.role || role;
		},
		removeChild: function (childIndex) {
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					if (childIndex === 0) {
						this.family.users.splice(i, 1);
						return;
					}
					childIndex--;
				}
			}
		}
	}
};
</script>
<style>
.hs_method {
	border-bottom: 2px solid #eee;
	padding: 7px;
}
.card-sub-title {
 margin-top: 20px;
}
.wizard-page {
	margin: 3rem 0;
}
</style>



// WEBPACK FOOTER //
// Registration.vue?6d8e23c0